<script lang="ts">
  /** A lift's lamp: lit amber when turning, an empty ring when stopped or held. */
  let {
    on = false,
    small = false,
    bare = false,
  }: { on?: boolean; small?: boolean; bare?: boolean } = $props()
</script>

<i class="lamp" class:on class:small class:bare aria-hidden="true"></i>

<style>
  .lamp {
    flex: none;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    border: 1.5px solid var(--ink-3);
  }
  .on {
    border-color: var(--amber);
    background: var(--amber);
    box-shadow: 0 0 0 3px var(--amber-halo);
  }
  .small {
    width: 7px;
    height: 7px;
  }
  .small.on,
  .bare.on {
    box-shadow: none;
  }
</style>
